import React,  {useState} from "react";
import { Link   } from "react-router-dom";
import {
  useConcallsQuery
} from '../../data/concall-data';
import { formatPostTime, APP_URL } from "../../components/config/Common";
import { useSiteSettings } from '../../contexts/site-settings/site-settings';

import { MdOutlineWatchLater } from "react-icons/md";
import { FaFilePdf, FaYoutube } from "react-icons/fa";
import { BiSolidVideoRecording } from "react-icons/bi";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const CompanyConcall = ({tag}) => {
    console.log('symbol===', tag)
    const { sitelogo } = useSiteSettings();
    const {
        records,        
        isLoading: loading,
        error,
    } = useConcallsQuery({ tag });

    console.log('concalls====', records)
    
    const formatNewsTime = (date) => {
      const now = dayjs();
      const postDate = dayjs(date);
      const diffInDays = now.diff(postDate, "day");
    
      // Show relative time for first 1 days
      /* if (diffInDays < 1) {
        const diffInMinutes = now.diff(postDate, "minute");
    
        if (diffInMinutes < 1) return "just now";
        if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
    
        const diffInHours = now.diff(postDate, "hour");
        return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
      } */
    
      // After 1 days show full date
      return postDate.format("MMM YYYY");
    };

    return(
        <>
            {!records ? null
                :
            <section className="bg-white shadow-md z-50 rounded-xl p-5">
                <h2 className="text-2xl font-semibold mb-5">CONCALL</h2>
                {records?.length === 0 && (
                    <p>CONCALL records are currently unavailable. Our team is actively working on updating them, stay tuned for the latest concall updates.</p>
                )}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {
                    !loading && records?.map(val=>(
                        <div className="flex items-center justify-between rounded-xl border border-gray-200 overflow-hidden transition duration-300 group">
                            <h2 className="text-lg p-4 overflow-hidden">{formatNewsTime(val?.concall_qtr)}</h2>
                            <div className="flex items-center justify-center px-4 py-2 gap-3">
                                {val?.youtube_url && (
                                    <Link title="YouTube" to={val?.youtube_url} target="_blank" className="text-blue-600 hover:underline">
                                        <FaYoutube size={35} color="red" />
                                    </Link>
                                )}
                                {val?.doc_url && (
                                    <Link title="Document" to={val?.doc_url} target="_blank" className="text-blue-600 hover:underline">
                                        <FaFilePdf size={25} color="black" />
                                    </Link>
                                )}
                                {val?.recording_url && (
                                    <Link title="Recording" to={val?.recording_url} target="_blank" className="text-blue-600 hover:underline">
                                        <BiSolidVideoRecording size={30} className="text-accent" />
                                    </Link>
                                )}
                            </div>
                        </div>
                    ))
                }
                </div>                
                
            </section>
            }
            </>
    )

}
export default CompanyConcall